<template>
  <FormDialogLayout :editable="isNewItem">
    <template #header>
      <v-app-bar flat>
        <v-toolbar-title>
          {{ isNewItem ? formtitle + DIALOG_TITLE_ADDITIONS.ADD : formtitle }}
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn
          v-if="!editable"
          class="mr-5"
          color="primary"
          :disabled="disableBtnEdit"
          @click="onEditable"
        >
          {{ DIALOG_BUTTON_NAMES.EDIT }}
        </v-btn>
        <v-btn icon @click="onClickBtnClose">
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <template v-slot:extension>
          <v-tabs v-model="tab" align-with-title>
            <v-tabs-slider color="primary"></v-tabs-slider>
            <v-tab v-for="(form, key) in FORMS" :key="key">
              {{ form.title }}
            </v-tab>
          </v-tabs>
        </template>
      </v-app-bar>
    </template>
    <template #main="{ params }">
      <ValidationObserver ref="observer" v-slot="observer">
        <v-tabs-items v-model="tab">
          <v-tab-item>
            <SitesFormPage1
              :editable="editable"
              :item="item"
              :isNewItem="isNewItem"
              :mainHeight="params.mainHeight"
              @formUpdate="formUpdate"
            />
          </v-tab-item>
        </v-tabs-items>
        <ValidationCallback :observer="observer" @callback="updateValidate" />
      </ValidationObserver>

      <Popup width="500px" :dialog="isShowConfirmDialog">
        <ConfirmDialog
          @close="onClickBtnCancelForm"
          @yes="closeForm"
          :isClose="true"
          :isCenter="false"
          title="フォームを閉じる確認"
          text="フォームを閉じますがよろしいですか？
        入力内容は保存されません。

        このページから移動してもよろしいですか？"
        />
      </Popup>
    </template>
    <template #footer>
      <v-toolbar>
        <v-spacer></v-spacer>
        <v-btn
          v-if="editable"
          class="mr-5"
          outlined
          color="success"
          @click="isShowConfirmDialog = true"
        >
          {{ DIALOG_BUTTON_NAMES.CANCEL }}
        </v-btn>
        <v-btn
          v-if="editable"
          class="ml-5"
          :disabled="!valid"
          color="primary"
          :key="keyButton"
          @click.once="onSubmit"
        >
          {{ DIALOG_BUTTON_NAMES.SAVE }}
        </v-btn>
      </v-toolbar>
    </template>
  </FormDialogLayout>
</template>
<script>
import { Store } from "@/store/Store.js";
import _ from "lodash";
import { ValidationObserver } from "vee-validate";
import ValidationCallback from "../elements/ValidationCallback.vue";
import {
  COMPANY_TYPE,
  DIALOG_BUTTON_NAMES,
  DIALOG_TITLE_ADDITIONS,
} from "@/constants/COMMON";

// Components
import Popup from "@/components/common/Popup.vue";
import FormDialogLayout from "@/components/layout/FormDialogLayout";
import ConfirmDialog from "@/components/dialog/ConfirmDialog.vue";
import SitesFormPage1 from "@/components/forms/sites/SitesFormPage1.vue";

const TITLE = {
  NEW: "現場情報",
  EDIT: "現場情報",
};
const STORE = "Sites";
const FORMS = {
  SitesFormPage1: { id: 1, title: "基本情報" },
};

export default {
  data: () => {
    return {
      DIALOG_TITLE_ADDITIONS,
      DIALOG_BUTTON_NAMES,
      FORMS,
      COMPANY_TYPE,
      valid: false,
      tab: null,
      editable: false,
      isShowConfirmDialog: false,
      isClickCloseBtn: false,
      beforeUpdateItem: {},
    };
  },
  components: {
    ValidationObserver,
    ValidationCallback,
    Popup,
    FormDialogLayout,
    ConfirmDialog,
    SitesFormPage1,
  },
  props: {
    item: Object,
    isNewItem: Boolean,
    keyButton: Boolean,
  },
  mounted() {
    this.$watch(
      () => this.isNewItem,
      (flag) => {
        if (flag) this.editable = true;
      },
      {
        immediate: true,
        deep: true,
      }
    );
    this.$watch(
      () => [Store.getters[`${STORE}/getSitesDetail`], this.editable],
      (data) => {
        if (!this.isNewItem) {
          this.beforeUpdateItem = _.cloneDeep(data[0]);
        }
      },
      {
        immediate: true,
        deep: true,
      }
    );
  },
  computed: {
    loginUser() {
      return Store.state.Login.user;
    },
    companyType() {
      return this.loginUser?.company_type;
    },
    formtitle() {
      return this.isNewItem ? TITLE.NEW : TITLE.EDIT;
    },
    disableBtnEdit() {
      switch (this.companyType) {
        case this.COMPANY_TYPE.PARTNER:
        case this.COMPANY_TYPE.RENTAL:
          return true;
        case this.COMPANY_TYPE.OWNER:
          if (this.item?.asigned_field_type === 1) return false;
          else if (this.loginUser?.role === 9) return false;
          else if (this.loginUser?.role === 1) return false;
          else return true;
        default:
          return false;
      }
    },
  },
  methods: {
    formUpdate(params) {
      this.$emit("formUpdate", params);
    },
    onEditable() {
      this.editable = true;
    },
    onDetail() {
      this.editable = false;
    },
    onSubmit() {
      this.$emit("submit");
    },
    updateValidate({ valid }) {
      this.valid = valid;
    },
    closeForm() {
      if (this.editable && !this.isNewItem && !this.isClickCloseBtn) {
        this.isShowConfirmDialog = false;
        const item = _.cloneDeep(this.beforeUpdateItem);
        this.formUpdate(item);
        this.editable = false;
      } else {
        this.$emit("cancel");
      }
    },
    onClickBtnClose() {
      if (!this.editable && !this.isNewItem) {
        this.$emit("cancel");
      } else {
        this.isClickCloseBtn = true;
        this.isShowConfirmDialog = true;
      }
    },
    onClickBtnCancelForm() {
      this.isShowConfirmDialog = false;
      this.isClickCloseBtn = false;
    },
  },
};
</script>
